// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zHFu1","name":"styles_name__NL6Ol","phone":"styles_phone__1Ggh5"};